import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/Api';
import { api_url_v1 } from '../utils/Config';

const initialState = {
  items: [],
  selectedApplicant: null,
  meta: {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0
  },
  loading: false,
  error: null
};

export const fetchApplicants = createAsyncThunk(
  'applicants/fetchApplicants',
  async ({ page, limit,filter,filter_type,search }, { getState }) => {
    const { auth: { token } } = getState();
    const params = {
      page,
      limit,
      [`filter[${filter_type}]`]: `${filter}`,
      search,
      sort: '-created_at',

    }
    const response = await api.get(`${api_url_v1}/applicants`, {
      params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    
    return {
      data: response.data.data || [],
      meta: response.data.meta || {
        current_page: page,
        last_page: 1,
        per_page: limit,
        total: 0
      }
    };
  }
);

export const fetchApplicantDetails = createAsyncThunk(
  'applicants/fetchApplicantDetails',
  async (slug, { getState }) => {
    const { auth: { token } } = getState();
    const response = await api.get(`${api_url_v1}/applicants/${slug}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  }
);


export const updateApplicantStatus = createAsyncThunk(
  'applicants/updateApplicantStatus',
  async ({ applicantId, status }, { getState }) => {
    const { auth: { token } } = getState();
    const response = await api.put(`${api_url_v1}/applicants/${applicantId}/approve-reject`, { status }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return { applicantId, status }; 
  }
);

const applicantSlice = createSlice({
  name: 'applicantsSlice',
  initialState,
  reducers: {
   setSelectedApplicant: (state, action) => {
      state.selectedApplicant = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicants.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(fetchApplicants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchApplicantDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicantDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedApplicant = action.payload.data;
      })
      .addCase(fetchApplicantDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateApplicantStatus.pending, (state, action) => {
        // state.loading=true
       })
       .addCase(updateApplicantStatus.fulfilled, (state, action) => {
        const { applicantId, status } = action.payload;
        const applicant = state.items.find(applicant => applicant.id === applicantId);
        if (applicant) {
          applicant.status = status;
        }
        if (state.selectedApplicant?.id === applicantId) {
          state.selectedApplicant.status = status;
        }

          state.loading = false;
      });

    
     
  }
});

export const {setSelectedApplicant } = applicantSlice.actions;
export default applicantSlice.reducer;
